module.exports = __webpack_public_path__ + "img/picto-enedis-compact-e-bleu-fd-blanc.39b8cabd.png";